import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { authFetch } from "../services/authAPI";
import Field from "../components/Field";
import moment from "moment";
import "moment/locale/fr";
import Modal from "../components/Modal";
import Select from "../components/Select";

export default function TicketsPage() {
    const navigate = useNavigate();
    const [search, setSearch] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const entriesPerPage = 10;

    const [showModal, setShowModal] = useState(false);

    const [tickets, setTickets] = useState([]);

    const [priorities, setPriorities] = useState([]);
    const [vehicles, setVehicles] = useState([]);

    const [vehicle, setVehicle] = useState("");
    const [mileage, setMileage] = useState("");
    const [description, setDescription] = useState("");
    const [priority, setPriority] = useState("");
    const [violations, setViolations] = useState([]);

    async function fetchTickets() {
        try {
            const response = await authFetch(`${process.env.REACT_APP_API_URL}/api/tickets`);
            const data = await response.json();
            setTickets(data);
        } catch (error) {
            // silently fail
        }
    }

    async function fetchTicketPriorities() {
        try {
            const response = await authFetch(`${process.env.REACT_APP_API_URL}/api/ticket_priorities`);
            const data = await response.json();
            setPriorities(data);
        } catch (error) {
            // silently fail
        }
    }

    async function fetchVehicles() {
        try {
            const response = await authFetch(`${process.env.REACT_APP_API_URL}/api/vehicles`);
            const data = await response.json();
            setVehicles(data);
        } catch (error) {
            // silently fail
        }
    }

    async function handleCreateTicket() {
        try {
            const response = await authFetch(`${process.env.REACT_APP_API_URL}/api/tickets`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    priority: priority,
                    vehicle: '/api/vehicles/' + vehicle,
                    mileage: mileage !== "" ? parseInt(mileage, 10) : null,
                    description: description
                }),
            });
            if (!response.ok) {
                const errorData = await response.json();
                setViolations(errorData.violations ?? []);
                return;
            }
            setShowModal(false);
            setViolations([]);
            fetchTickets();
        } catch (error) {
            // silently fail
        }
    }

    useEffect(() => {
        fetchTickets();
        fetchTicketPriorities();
        fetchVehicles()
    }, []);

    const filteredTickets = tickets.filter(
        (ticket) =>
            ticket.ticketNumber?.toLowerCase().includes(search.toLowerCase()) ||
            ticket.priority?.toLowerCase().includes(search.toLowerCase()) ||
            ticket.vehicle?.licensePlateNumber?.toLowerCase().includes(search.toLowerCase()) ||
            ticket.vehicle?.name?.toLowerCase().includes(search.toLowerCase()),
    );

    const totalPages = Math.ceil(filteredTickets.length / entriesPerPage);

    const paginatedTickets = filteredTickets.slice(
        (currentPage - 1) * entriesPerPage,
        currentPage * entriesPerPage,
    );


    const PRIORITIES_LABELS = Object.fromEntries(
        priorities.map((b) =>
            [b.value, b.label]
        )
    );

    const PRIORITIES_CLASSES = {
        LOW: "primary",
        MEDIUM: "warning",
        HIGH: "danger"
    };

    const STATUS_LABELS = {
        PENDING: "En attente",
        IN_PROGRESS: "En cours",
        SCHEDULED: "Programmé",
        NOT_REQUIRED: "Non nécessaire",
        RESOLVED: "Résolu"
    }

    const STATUS_CLASSES = {
        PENDING: "secondary",
        IN_PROGRESS: "primary",
        SCHEDULED: "info",
        NOT_REQUIRED: "dark",
        RESOLVED: "success"
    }

    return (
        <>
            <Modal
                title={"Créer un ticket"}
                body={
                    <>
                        {violations.length > 0 && (
                            <div className="alert alert-danger d-flex align-items-center" role="alert">
                                <i className="fas fa-times-circle me-3"></i>
                                <ul className="mb-0 list-unstyled">
                                    {violations.map((v, i) => (
                                        <li key={i}>{v.message}</li>
                                    ))}
                                </ul>
                            </div>
                        )}
                        <Select
                            name="vehicle"
                            label="Véhicule"
                            value={vehicle}
                            onChange={(e) => setVehicle(e.target.value)}
                            options={
                                vehicles.map((v) => ({
                                    value: v.id,
                                    label: v.licensePlateNumber + (v.name ? ` (${v.name})` : '')
                                }))
                            }
                        />
                        <Field
                            name="mileage"
                            label="Kilométrage"
                            value={mileage}
                            onChange={(e) => setMileage(e.target.value)}
                            type="number"
                        />
                        <Select
                            name="priority"
                            label="Priorité"
                            value={priority}
                            onChange={(e) => setPriority(e.target.value)}
                            options={
                                priorities.map((p) => ({
                                    value: p.value,
                                    label: p.label
                                }))
                            }
                        />
                        <Field
                            name="description"
                            label="Description"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            type="text"
                        />
                    </>
                }
                button={{
                    close:"Annuler",
                    valid:"Créer"
                }}
                showModal={showModal}
                setShowModal={setShowModal}
                onSubmit={handleCreateTicket}
            />
            <section>
                <div className="card mb-4">
                    <div className="card-header py-3">
                        <div className="row py-3">
                            <div className="col-sm-6 text-center text-sm-start">
                                <h5 className="mb-4 mb-sm-0 mt-2">
                                    Gestion des tickets
                                </h5>
                            </div>

                            <div className="col-sm-6 text-center text-sm-end">
                                <button
                                    type="button"
                                    className="btn btn-primary me-2"
                                    onClick={() => { setShowModal(true); setViolations([]); }}
                                >
                                    Ajouter
                                    <i className="fas fa-plus ms-2"></i>
                                </button>
                            </div>

                        </div>
                    </div>
                    <div className="card-body py-5 px-5">
                        <div className="d-flex align-items-center mb-4">
                            <div className="flex-grow-1">
                                <Field
                                    name="search"
                                    label="Rechercher"
                                    value={search}
                                    onChange={(e) => {
                                        setSearch(e.target.value);
                                        setCurrentPage(1);
                                    }}
                                    type="text"
                                    margin={false}
                                />
                            </div>
                        </div>
                        <table className="table table-hover card-body align-middle mb-0 bg-white">
                            <thead className="bg-light">
                                <tr>
                                    <th className="text-left">Ticket</th>
                                    <th className="text-center">Véhicule</th>
                                    <th className="text-center">Priorité</th>
                                    <th className="text-center">Statut</th>
                                    <th className="text-center">Activité</th>
                                    <th className="text-center">Visible</th>
                                </tr>
                            </thead>
                            <tbody>
                                {paginatedTickets.map((ticket) => (
                                    <tr key={ticket.id} onClick={() => navigate(`/tickets/${ticket.id}`)} style={{ cursor: "pointer" }}>
                                        <td>
                                            <div className="d-flex align-items-center">
                                                <div>
                                                    <p className="fw-bold mb-1">
                                                        {ticket.ticketNumber}
                                                    </p>
                                                    <p className="text-muted mb-0">
                                                        Créé le{" "}
                                                        {moment(ticket.createdAt)
                                                            .locale("fr")
                                                            .format("dddd Do MMMM [à] HH:mm")}
                                                    </p>
                                                </div>
                                            </div>
                                        </td>
                                        <td className="text-center">
                                                {ticket.vehicle.name && (
                                                    <span className="text-muted">
                                                        {ticket.vehicle.name}{" "}
                                                        ┃{" "}
                                                    </span>
                                                )}
                                                <span className="fw-bold">{ticket.vehicle.licensePlateNumber}</span>
                                        </td>
                                        <td className="text-center">
                                            <span className={"badge badge-" + PRIORITIES_CLASSES[ticket.priority]}>
                                                {PRIORITIES_LABELS[ticket.priority]}
                                            </span>
                                        </td>
                                        <td className="text-center">
                                            <span className={"badge badge-" + STATUS_CLASSES[ticket.status]}>
                                                {STATUS_LABELS[ticket.status]}
                                            </span>
                                        </td>
                                        <td className="text-center">
                                            {ticket.totalActivities}
                                        </td>
                                        <td className="text-center">
                                            {ticket.isVisible ? (
                                                <i className="fa-solid fa-circle-check text-success"></i>
                                            ) : (
                                                <i className="fa-solid fa-circle-xmark text-danger"></i>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        {totalPages > 1 && (
                            <nav className="d-flex justify-content-end mt-4">
                                <ul className="pagination pagination-sm mb-0">
                                    <li
                                        className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                                    >
                                        <button
                                            className="page-link"
                                            onClick={() => setCurrentPage((p) => p - 1)}
                                        >
                                            <i className="fas fa-chevron-left fa-xs"></i>
                                        </button>
                                    </li>
                                    {Array.from({ length: totalPages }, (_, i) => (
                                        <li
                                            key={i}
                                            className={`page-item ${currentPage === i + 1 ? "active" : ""}`}
                                        >
                                            <button
                                                className="page-link"
                                                onClick={() => setCurrentPage(i + 1)}
                                            >
                                                {i + 1}
                                            </button>
                                        </li>
                                    ))}
                                    <li
                                        className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
                                    >
                                        <button
                                            className="page-link"
                                            onClick={() => setCurrentPage((p) => p + 1)}
                                        >
                                            <i className="fas fa-chevron-right fa-xs"></i>
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        )}
                    </div>
                </div>
            </section>
        </>
    );
}
